<template>
	<div :class="newUserTipsClasses" v-if="show">
		<div class="new-user-overlay-wrap">
			<div class="pointer-wrap">
				<font-awesome-icon icon="hand-pointer" class="pointer" />
			</div>

			<div class="highlighter" />

			<div class="descriptions">
				<p class="general">Update Your Company/Personal Details</p>

				<p class="about client">Complete Your Profile</p>

				<p class="about contractor">
					Complete Your Services, Regions, Accrediations & Tools and Machinery<span class="mobile"
						><br />(This menu scrolls horizontally)</span
					>
				</p>

				<p class="mobile-menu">Click Here To Browse Services</p>

				<p class="jobs">View Jobs</p>

				<p class="products">Browse Our Wide Range Of Products</p>
			</div>
		</div>

		<div class="new-user-overlay-fixed">
			<span class="next" @click="nextTip">Next Tip</span>

			<p>Here's some tips to get you started!!</p>
		</div>
	</div>
</template>

<script>
import { ref, computed, onMounted, getCurrentInstance } from "vue";

export default {
	name: "InstructionTips",
	props: {
		userInfo: {
			type: Object,
			default: function () {
				return {};
			},
		},
		showingTopMessage: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["finished"],
	setup(props, { emit }) {
		const vm = getCurrentInstance().proxy;
		const store = vm.$store;

		const newUserTips = ref([
			{ type: "general", showMobileMenu: false },
			{ type: "about", showMobileMenu: false },
			{ type: "mobile-menu", showMobileMenu: true, maxWidth: 767, showMobileMenuDelay: 1500 },
			{ type: "jobs", showMobileMenu: true },
			{ type: "products", showMobileMenu: true },
		]);
		const newUserTipIndex = ref(0);
		const showNewUserTips = ref(true);
		const showingMobileMenu = ref(false);

		const updateVar = (payload) => store.commit("general/updateVar", payload);

		const newUserTipsClasses = computed(() => {
			let c = {};
			c["new-user-overlay"] = true;
			if (newUserTips.value[newUserTipIndex.value]) {
				c[newUserTips.value[newUserTipIndex.value].type] = true;
			}
			c["has-no-top-message"] = !props.showingTopMessage;
			if (props.userInfo.access) c[props.userInfo.access.type] = true;
			return c;
		});

		const show = computed(() => {
			return showNewUserTips.value && !!props.userInfo.access && props.userInfo.access.type !== "admin" && props.userInfo.showInstructions;
		});

		const mobileMenu = (hide) => {
			updateVar({ varName: "mobileMenu", info: hide });
		};

		const nextTip = () => {
			let a = newUserTipIndex.value + 1;
			if (typeof newUserTips.value[a] !== "undefined") {
				newUserTipIndex.value++;
				if (newUserTips.value[newUserTipIndex.value].maxWidth && newUserTips.value[newUserTipIndex.value].maxWidth < window.innerWidth) {
					nextTip();
					return;
				}
				let delay = newUserTips.value[newUserTipIndex.value].showMobileMenuDelay
					? newUserTips.value[newUserTipIndex.value].showMobileMenuDelay
					: 1;
				setTimeout(() => {
					if (showingMobileMenu.value !== newUserTips.value[newUserTipIndex.value].showMobileMenu) {
						mobileMenu(newUserTips.value[newUserTipIndex.value].showMobileMenu);
						showingMobileMenu.value = newUserTips.value[newUserTipIndex.value].showMobileMenu;
					}
				}, delay);
			} else {
				showNewUserTips.value = false;
				if (showingMobileMenu.value) {
					mobileMenu(false);
				}
				emit("finished");
			}
		};

		onMounted(() => {
			if (!show.value) return;
			setTimeout(() => {
				window.scrollTo(0, 0);
				updateVar({ varName: "fullMenu", info: true });
			}, 1);
		});

		return {
			newUserTipsClasses,
			show,
			nextTip,
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../assets/css/less/_helper.less";
@import "./../assets/css/less/_settings.less";
.new-user-overlay {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 999998;
	text-align: center;
	box-sizing: border-box;
	overflow: hidden;

	.descriptions {
		display: inline;
	}

	.pointer-wrap {
		width: 70px;
		height: 70px;
		.trans;
		position: relative;
		z-index: 2;
		margin-top: 125px;
		display: inline-block;
		animation: MoveUpDown 2s linear infinite;

		.pointer {
			width: 100%;
			height: 100%;
			color: @formDefaultColour;
			display: inline-block;
		}
	}

	p {
		color: #fff;
		margin: 0;
		padding: 10px;
		display: none;
		position: relative;
		text-align: center;
		.trans;
		position: relative;
		z-index: 2;
	}

	.new-user-overlay-wrap {
		width: 200px;
		display: inline-block;
	}

	.highlighter {
		box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.7);
		width: 75px;
		height: 27px;
		top: 95px;
		left: 82px;
		position: absolute;
		z-index: 1;
		border-radius: @radiusXs;
	}

	&.has-top-message {
		.highlighter {
		}

		.pointer-wrap {
		}
	}

	.new-user-overlay-fixed {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 999999;

		.next {
			display: block;
			font-weight: @bold;
			color: #fff;
			text-align: center;
			position: absolute;
			bottom: 20px;
			width: 200px;
			left: 50%;
			margin-left: -100px;
			background-color: @formDefaultColour;
			padding: 10px;
			cursor: pointer;
			border-radius: @radiusSm;
			.trans;
			&:hover {
				color: @formDefaultColour;
				background-color: #fff;
			}
		}

		p {
			color: #fff;
			position: absolute;
			padding: 0;
			margin: 0;
			width: 200px;
			bottom: 100px;
			left: 50%;
			margin-left: -100px;
			z-index: 99;
			display: block;
			text-align: center;
			font-size: 20px;
		}
	}

	&.has-no-top-message {
		.highlighter {
			top: 59px;
		}

		.pointer-wrap {
			margin-top: 89px; // - 36
		}
	}

	&.general {
		text-align: left;

		.new-user-overlay-wrap {
			margin-left: 98px;
		}

		.general {
			display: block;
			left: -60px;
		}
	}

	&.about {
		text-align: left;

		&.contractor {
			.about.contractor {
				display: block;
				left: -66px;

				.mobile {
					color: #fff;
				}
			}

			.pointer-wrap {
				animation: MoveAngle 2s linear infinite;

				.pointer {
					transform: rotate(45deg);
				}
			}

			.new-user-overlay-wrap {
				margin-left: 85px;
			}

			.highlighter {
				left: 163px;
				width: 452px;
			}
		}

		&.client {
			.about.client {
				display: block;
				left: -67px;
				text-align: center;
			}

			.highlighter {
				left: 159px;
				width: 63px;
			}

			.new-user-overlay-wrap {
				margin-left: 168px;
			}
		}
	}

	&.mobile-menu {
		text-align: left;

		.pointer-wrap {
			margin-top: 44px;
			animation: MoveAngle 2s linear infinite;

			.pointer {
				transform: rotate(45deg);
			}
		}

		.new-user-overlay-wrap {
			margin-left: calc(100% - 115px);
		}

		.mobile-menu {
			display: block;
			left: -113px;
			text-align: right;
		}

		.highlighter {
			top: 9px;
			left: auto;
			right: 13px;
			width: 28px;
		}
	}

	&.jobs {
		text-align: left;

		.pointer-wrap {
			margin-top: 138px;
		}

		.new-user-overlay-wrap {
			margin-left: 60px;
		}

		.jobs {
			display: block;
			left: -60px;
		}

		.highlighter {
			top: 105px;
			left: 14px;
			width: 90px;
		}
	}

	&.products {
		text-align: left;

		.pointer-wrap {
			margin-top: 185px;
		}

		.new-user-overlay-wrap {
			margin-left: 60px;
		}

		.products {
			display: block;
			left: -60px;
		}

		.highlighter {
			top: 156px;
			left: 14px;
			width: 117px;
		}
	}
}

@media screen and (min-width: 600px) {
	.new-user-overlay {
		&.about {
			&.contractor {
				.about.contractor {
					.mobile {
						display: none;
					}
				}
			}
		}
	}
}

@media screen and (min-width: 768px) {
	.new-user-overlay {
		.highlighter {
			top: 113px;
			left: 242px; // + 94 for big menu
		}

		.pointer-wrap {
			margin-top: 145px;
		}

		&.has-no-top-message {
			.highlighter {
				top: 77px;
			}

			.pointer-wrap {
				margin-top: 109px; // - 36
			}
		}

		&.general {
			.new-user-overlay-wrap {
				margin-left: 254px;
			}

			.general {
				display: block;
				left: -60px;
			}
		}

		&.about {
			&.contractor {
				.new-user-overlay-wrap {
					margin-left: 309px;
				}

				.highlighter {
					left: 319px;
				}

				.about.contractor {
					text-align: center;
					left: -50px;
				}

				.pointer-wrap {
					margin-top: 159px;
				}
			}

			&.client {
				.highlighter {
					left: 319px;
				}

				.new-user-overlay-wrap {
					margin-left: 328px;
				}
			}
		}

		&.jobs {
			.highlighter {
				top: 129px;
				width: 82px;
			}

			.pointer-wrap {
				margin-top: 160px;
			}

			.new-user-overlay-wrap {
				margin-left: 41px;
			}
		}

		&.products {
			.highlighter {
				top: 183px;
				width: 109px;
			}

			.pointer-wrap {
				margin-top: 213px;
			}

			.new-user-overlay-wrap {
				margin-left: 41px;
			}

			.products {
				left: -40px;
			}
		}
	}
}

@media screen and (min-width: 1024px) {
	.new-user-overlay {
		.highlighter {
			left: 257px; // + 94 for big menu
		}

		&.general {
			.new-user-overlay-wrap {
				margin-left: 269px;
			}

			.general {
				display: block;
				left: -60px;
			}
		}

		&.about {
			&.contractor {
				.new-user-overlay-wrap {
					margin-left: 324px;
				}

				.highlighter {
					left: 334px;
				}
			}

			&.client {
				.highlighter {
					left: 334px;
				}

				.new-user-overlay-wrap {
					margin-left: 343px;
				}
			}
		}
	}
}

@keyframes MoveUpDown {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(15px);
	}
}
@keyframes MoveAngle {
	0%,
	100% {
		transform: translateY(0) translateX(0);
	}
	50% {
		transform: translateY(-15px) translateX(15px);
	}
}
</style>